import { Expert } from "@hooks/useGetExpert";
import mediaQuery from "@utils/mediaQuery";
import styled from "styled-components";

interface Props {
  title: string;
  experts?: Expert[];
}

const Title = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 28.8px;
  margin-bottom: 24px;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid #c3d4e1;
  background-color: #fff;
  min-width: 0;
  word-break: break-word;

  font-size: 16px;
  font-weight: 400;
  line-height: 25.6px;

  strong {
    font-weight: 700;
    margin-bottom: 8px;
  }

  span {
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-bottom: 24px;

  ${mediaQuery("tablet")`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${mediaQuery("desktop")`
    grid-template-columns: repeat(3, 1fr);
  `}
`;

const ExpertCards = ({ title, experts }: Props) => {
  return (
    <>
      <Title>{title}</Title>
      <CardWrapper>
        {experts?.map((expert) => (
          <Card key={expert.title}>
            <strong>{expert.title}</strong>
            <span>{expert.description}</span>
            <span>{expert.email}</span>
            <span>{expert.phone}</span>
          </Card>
        ))}
      </CardWrapper>
    </>
  );
};

export default ExpertCards;
